import * as React from 'react';
import * as ReactDOM from 'react-dom';
import {CircleLinkPanel} from '@bepure/tarkin';
import {Props as PanelProps} from '@bepure/tarkin/dist/components/CircleLinkPanel/CircleLinkPanel';
import {PagesFeed} from '@bepure/tarkin';
import {PagesFeedProps} from '@bepure/tarkin/dist/components/PagesFeed/PagesFeed';

declare const BASE_API_URL: string;

interface State {
    selectedCategory?: string;
    linkButtons: PanelProps['links'];
}

interface Props {
    title: string;
    categories: {[category: string]: Category};
    tags: {[category: string]: PagesFeedProps['items']};
}

interface Category {
    title: string;
    image_url: string;
    text: string;
}

export class BlogTagPanel extends React.PureComponent<Props, State> {

    constructor(props: Props) {
        super(props);
        this.state = {
            linkButtons: [],
        };
    }

    public componentDidMount() {
        const keys = Object.keys(this.props.categories);
        const buttons: PanelProps['links'] = Object.keys(this.props.tags)
            .map(key => key.toLowerCase())
            .filter(key => keys.includes(key))
            .map(key => this.getLinkButton(key));
        this.setState({
            linkButtons: buttons,
        });
    }

    public render() {
        return (
            <React.Fragment>
                <CircleLinkPanel title={this.props.title} links={this.state.linkButtons} selected={this.state.selectedCategory}/>
                {this.state.selectedCategory ?
                    <PagesFeed
                        title={this.props.categories[this.state.selectedCategory].title}
                        items={this.props.tags[this.state.selectedCategory]}
                        variant={'blue'}
                        text={this.props.categories[this.state.selectedCategory].text}
                        close={this.closePagesFeed}
                        fadeIn
                    /> : <></>}
            </React.Fragment>
        );
    }

    private closePagesFeed = () => {
        this.setState({
            selectedCategory: undefined,
        });
    }

    private getLinkButton = (category: string): PanelProps['links'][0] => {
        return {
            action: () => {
                if (this.state.selectedCategory === category) {
                    this.closePagesFeed();
                } else {
                    this.setState({
                        selectedCategory: category,
                    });
                }
            },
            key: category,
            src: this.props.categories[category.toLowerCase()].image_url,
            label: category.toUpperCase(),
            plus: true,
        };
    }
}

const BlogTagPanelFunc = () => {
    const elements = document.getElementsByClassName('blog-tag-panel');
    Array.from(elements).forEach(element => {
        const htmlElement = (element as HTMLElement);

        const title = htmlElement.dataset.title || '';
        let categories: {[category: string]: Category} = (htmlElement.dataset.categories ?  JSON.parse(htmlElement.dataset.categories) : JSON.parse('{"categories": {}}')).categories;
        categories = Object
            .keys(categories)
            .reduce((a, key) => ({...a, [key.toLowerCase()]: categories[key]}), {});

        getBlogs(Object.keys(categories).filter(key => key.length > 0)).then(resp => {
                const component = (
                    <BlogTagPanel title={title} tags={resp.tags} categories={categories}/>
                );
                ReactDOM.render(component, htmlElement);
            },
        );
    });
};

const getBlogs = async (categoryList: string[]) => {
    const response = await fetch(`${BASE_API_URL}/v1/blogs/by-tag`, {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            categories: categoryList,
            limit: 3,
        }),
    });
    try {
        const content = await response.json();
        return Promise.resolve(content);
    } catch (error) {
        throw Promise.reject({
            error: error.message,
        });
    }
};
export default BlogTagPanelFunc;
